import { BulkDownloadRequestDto } from '@asset-metrix/portal-gateway-client-js';
import { triggerDownloadWithAnchorTag } from '@asset-metrix/portal-ui';

import { HttpError } from '../errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const datatableDownloadDocuments = async ({
  widgetId,
  data,
  fileName,
}: {
  widgetId: string;
  data: BulkDownloadRequestDto;
  fileName?: string;
}) => {
  const response = await portalGatewayClient.table.downloadDocuments(
    widgetId,
    data
  );

  if (!response.ok) {
    throw new HttpError('Error downloading documents', response);
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);
  triggerDownloadWithAnchorTag(blobUrl, fileName);
};
